import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={17}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.547.27.352 17.896l8.195-4.124 7.805 4.124L8.547.271Z"
      fill="#636F7C"
    />
  </svg>
);

export default SvgComponent;
